import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Cpu, Activity, Zap, Lock, Eye, BarChart2, TrendingUp, AlertTriangle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

// --- VISUAL ASSETS ---

// SVG Dashboard Visualization
const DashboardSvg = () => (
  <svg viewBox="0 0 1200 675" className="w-full h-full rounded-xl shadow-2xl overflow-hidden bg-gray-900">
    <defs>
      <linearGradient id="grid-grad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#0f172a" stopOpacity="1" />
        <stop offset="100%" stopColor="#020617" stopOpacity="1" />
      </linearGradient>
      <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
        <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#1e293b" strokeWidth="1" opacity="0.5" />
      </pattern>
      <filter id="glow-blue">
        <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
        <filter id="glow-gold">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {/* Background */}
    <rect width="100%" height="100%" fill="url(#grid-grad)" />
    <rect width="100%" height="100%" fill="url(#grid)" />

    {/* Card 1: XAUUSD Live Pulse */}
    <g transform="translate(50, 50)">
      <rect width="1100" height="180" rx="10" fill="#0f172a" stroke="#0ea5e9" strokeWidth="1" opacity="0.8" />
      {/* Header */}
      <rect width="60" height="24" rx="4" x="20" y="20" fill="#0ea5e9" opacity="0.2" />
      <text x="50" y="37" fill="#0ea5e9" textAnchor="middle" fontSize="12" fontWeight="bold">LIVE</text>
      <text x="90" y="38" fill="white" fontSize="18" fontWeight="bold" letterSpacing="1">XAUUSD</text>
      <text x="1060" y="38" fill="#94a3b8" fontSize="12" textAnchor="end">TIMESTAMP: 7:00:06 PM</text>

      {/* Stats Row */}
      <line x1="20" y1="60" x2="1080" y2="60" stroke="#334155" />
      
      {/* Pattern */}
      <text x="30" y="85" fill="#64748b" fontSize="10" fontWeight="bold">PATTERN</text>
      <text x="30" y="105" fill="#f8fafc" fontSize="14" fontWeight="bold">MOMENTUM_DRIVE</text>

      {/* Regime */}
      <text x="300" y="85" fill="#64748b" fontSize="10" fontWeight="bold">REGIME</text>
      <text x="300" y="105" fill="#f8fafc" fontSize="14" fontWeight="bold">TREND_BULLISH</text>

      {/* Confidence */}
      <text x="550" y="85" fill="#64748b" fontSize="10" fontWeight="bold">CONFIDENCE</text>
      <text x="550" y="105" fill="#0ea5e9" fontSize="14" fontWeight="bold">75%</text>

      {/* Action */}
      <text x="800" y="85" fill="#64748b" fontSize="10" fontWeight="bold">ACTION</text>
      <rect x="795" y="88" width="60" height="24" rx="4" fill="#0ea5e9" opacity="0.2"/>
      <text x="825" y="105" fill="#0ea5e9" fontSize="12" fontWeight="bold" textAnchor="middle">TRADE</text>
      
      {/* Risk Scale - Gold */}
      <text x="1000" y="85" fill="#64748b" fontSize="10" fontWeight="bold">RISK SCALE</text>
      <rect x="950" y="93" width="100" height="6" rx="3" fill="#334155" />
      <rect x="950" y="93" width="75" height="6" rx="3" fill="#eab308" filter="url(#glow-gold)" />
      <text x="1070" y="100" fill="#eab308" fontSize="12" fontWeight="bold">1.5x</text>

       {/* Entry Bar */}
       <rect x="20" y="130" width="1060" height="30" rx="4" fill="#1e293b" stroke="#334155" />
       <text x="40" y="145" fill="#94a3b8" fontSize="10">ENTRY</text>
       <text x="40" y="156" fill="white" fontSize="14" fontWeight="bold">4519.47</text>
       
       <text x="960" y="145" fill="#94a3b8" fontSize="10">TAKE PROFIT</text>
       <text x="960" y="156" fill="#10b981" fontSize="12" fontWeight="bold">4579.54</text>

       <text x="1030" y="145" fill="#94a3b8" fontSize="10">STOP LOSS</text>
       <text x="1030" y="156" fill="#ef4444" fontSize="12" fontWeight="bold">4489.43</text>
       
       {/* Slider */}
       <line x1="150" y1="145" x2="900" y2="145" stroke="#334155" strokeWidth="2" />
       <circle cx="500" cy="145" r="4" fill="#0ea5e9" />
    </g>

    {/* Indicators Strip */}
    <g transform="translate(50, 240)">
        <rect width="1100" height="50" rx="4" fill="#0f172a" stroke="#334155" />
         <g transform="translate(0,0)">
            <text x="275" y="20" fill="#64748b" fontSize="10" textAnchor="middle">RSI</text>
            <text x="275" y="38" fill="white" fontSize="14" fontWeight="bold" textAnchor="middle">54.3</text>
            <line x1="366" y1="10" x2="366" y2="40" stroke="#334155" />
         </g>
         <g transform="translate(366,0)">
            <text x="183" y="20" fill="#64748b" fontSize="10" textAnchor="middle">TRND(H1)</text>
            <text x="183" y="38" fill="#10b981" fontSize="14" fontWeight="bold" textAnchor="middle">TREND_UP</text>
             <line x1="366" y1="10" x2="366" y2="40" stroke="#334155" />
         </g>
         <g transform="translate(732,0)">
            <text x="183" y="20" fill="#64748b" fontSize="10" textAnchor="middle">ADX</text>
            <text x="183" y="38" fill="#f8fafc" fontSize="14" fontWeight="bold" textAnchor="middle">38.5</text>
         </g>
    </g>
    
    {/* AI Reasoning Console */}
    <g transform="translate(50, 310)">
         <rect width="1100" height="150" rx="10" fill="#020617" stroke="#334155" strokeWidth="1" />
         <path d="M 10 30 L 150 30" stroke="#0ea5e9" strokeWidth="2" />
         <text x="25" y="20" fill="#0ea5e9" fontSize="12" fontWeight="bold">⚡ HON AI REASONING</text>
         <text x="160" y="20" fill="#64748b" fontSize="12" fontWeight="bold">◎ VISION</text>
         
         <text x="30" y="60" fill="#94a3b8" fontSize="14" fontFamily="monospace">
            {'>'} Taking MOMENTUM_DRIVE aligned with HTF Trend.
         </text>
         <text x="30" y="85" fill="#94a3b8" fontSize="14" fontFamily="monospace">
            {'>'} Deviation calculated: +2.1 Sigma on recent impulse.
         </text>
         <text x="30" y="110" fill="#94a3b8" fontSize="14" fontFamily="monospace">
            {'>'} Stop Loss placed below swing low (Liquidity protected).
         </text>
    </g>
    
    {/* Pulse Graph Line - Decorative */}
    <path d="M 850 150 Q 900 150, 920 120 T 950 80 T 980 130 T 1020 100" fill="none" stroke="#1e293b" strokeWidth="4" opacity="0.3" transform="translate(50,50)" />
  </svg>
);

// --- SECTIONS ---

const HonAiSentinel = () => {
    
    // Simplified access: Direct redirect to external dashboard
    const handleDashboardAccess = () => {
        window.location.href = "https://ksquants-hon-ai.web.app/";
    };

    return (
        <div className="bg-black text-white font-sans min-h-screen selection:bg-cyan-500/30 overflow-x-hidden">
            


            {/* 1. HERO SECTION */}
            <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
                 {/* Background Elements */}
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-900/20 via-black to-black z-0"></div>
                <div className="absolute top-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent"></div>
                
                {/* Content */}
                <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="inline-flex items-center gap-2 px-3 py-1 bg-cyan-900/30 border border-cyan-500/30 rounded-full mb-6 text-cyan-400 text-xs font-mono tracking-widest uppercase">
                            <span className="relative flex h-2 w-2">
                              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75"></span>
                              <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500"></span>
                            </span>
                            System Online
                        </div>

                        <h1 className="text-5xl md:text-8xl font-bold mb-6 tracking-tighter bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-600">
                            HON AI <br/> SENTINEL
                        </h1>
                    </motion.div>

                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto mb-10 leading-relaxed font-light"
                    >
                        <br className="hidden md:block"/>
                        This is a <span className="text-white font-medium">Neuro-Symbolic Trading Engine</span>. <br className="hidden md:block"/>
                        Combining the millisecond execution speed of institutional algorithms (MQL5) with the cognitive reasoning of <span className="text-cyan-400">HON AI</span>.
                    </motion.p>
                    
                    <motion.p
                         initial={{ opacity: 0, y: 20 }}
                         animate={{ opacity: 1, y: 0 }}
                         transition={{ delay: 0.4, duration: 0.8 }}
                         className="text-lg text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed font-light"
                    >
                        Unlike traditional bots that trade blindly, this system uses <span className="text-indigo-400">Reflective-Retrieval-Augmented Generation (RAG)</span> to make intelligent, adaptive trade decisions.
                    </motion.p>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.8 }}
                        className="flex flex-col sm:flex-row items-center justify-center gap-4"
                    >
                        <button onClick={handleDashboardAccess} className="px-8 py-4 bg-cyan-600 hover:bg-cyan-500 text-white font-bold text-lg rounded-none clip-path-slant min-w-[200px] transition-all hover:shadow-[0_0_30px_rgba(8,145,178,0.5)] flex items-center justify-center gap-2 group">
                             Access Dashboard <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
                        </button>
                         <button onClick={() => document.getElementById('technology').scrollIntoView({ behavior: 'smooth'})} className="px-8 py-4 bg-transparent border border-gray-700 hover:border-white text-gray-300 hover:text-white font-medium text-lg rounded-none min-w-[200px] transition-all">
                             View Technology
                        </button>
                    </motion.div>
                </div>
                
                 {/* Scroll Indicator */}
                <motion.div 
                    animate={{ y: [0, 10, 0] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="absolute bottom-10 left-1/2 -translate-x-1/2 text-gray-600"
                >
                    <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-cyan-500 to-transparent"></div>
                </motion.div>
            </section>


             {/* 2. PHILOSOPHY SECTION */}
             <section id="technology" className="py-24 bg-black relative border-t border-gray-900">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-20">
                         <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">Two Brains. <span className="text-cyan-500">Zero Lag.</span></h2>
                         <p className="text-gray-400 max-w-2xl mx-auto text-lg">Standard trading bots are blind. They trade indiscriminately through news events. HON AI operates on a revolutionary "Dual-Loop" architecture.</p>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-20 items-center">
                        {/* The Sentinel */}
                        <motion.div 
                            whileHover={{ scale: 1.02 }}
                            className="p-8 border border-gray-800 bg-gray-900/30 rounded-2xl relative group overflow-hidden"
                        >
                            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-600 to-transparent"></div>
                            <div className="mb-6 bg-blue-900/20 w-16 h-16 rounded-xl flex items-center justify-center border border-blue-500/20">
                                <Shield className="text-blue-500" size={32} />
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                                01. The Sentinel <span className="text-xs font-mono bg-blue-900/50 text-blue-300 px-2 py-1 rounded">LOCAL LOOP</span>
                            </h3>
                            <p className="text-gray-400 leading-relaxed">
                                Runs every second inside your terminal. It watches the market clock with <strong>zero latency</strong>. If High-Impact news is detected, it locks the gates instantly. No internet lag. No slippage. Pure safety.
                            </p>
                        </motion.div>

                         {/* The Strategist */}
                         <motion.div 
                            whileHover={{ scale: 1.02 }}
                            className="p-8 border border-gray-800 bg-gray-900/30 rounded-2xl relative group overflow-hidden"
                        >
                             <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-600 to-transparent"></div>
                             <div className="mb-6 bg-purple-900/20 w-16 h-16 rounded-xl flex items-center justify-center border border-purple-500/20">
                                <Cpu className="text-purple-500" size={32} />
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                                02. The Strategist <span className="text-xs font-mono bg-purple-900/50 text-purple-300 px-2 py-1 rounded">CLOUD LOOP</span>
                            </h3>
                            <p className="text-gray-400 leading-relaxed">
                                Runs every hour. It uploads market structure, RSI, and candle geometry to the Cloud. There, our fine-tuned <strong>LLM Strategist</strong> analyzes the data like a Senior Macro Analyst, deciding not just <em>if</em> to trade, but <em>how heavy</em> to bet.
                            </p>
                        </motion.div>
                    </div>
                </div>
            </section>
            
            {/* 3. RETAIL TRANSLATION SECTION */}
            <section className="py-24 bg-gray-950 relative border-t border-gray-900">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-16">
                         <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">Institutional Power, <span className="text-cyan-500">Retail Access.</span></h2>
                         <p className="text-gray-400 max-w-2xl mx-auto text-lg">Why This Beats Standard EAs</p>
                    </div>

                    <div className="grid gap-6">
                        {[
                            {
                                tech: "Neuro-Symbolic Architecture",
                                title: "Disciplined Genius",
                                desc: "Most bots are dumb mathematical formulas. Ours combines an AI Brain (to find trades) with a Hard-Coded Safety Switch (to manage risk). It thinks like a human but executes like a machine."
                            },
                            {
                                tech: "Vision Shadow Mode",
                                title: "It Sees the Chart Like You Do",
                                desc: "Standard EAs only look at numbers. HON AI literally \"looks\" at the chart shape (as seen in your dashboard) to spot Bull Flags, Wedges, and Head & Shoulders patterns that math-only bots miss."
                            },
                            {
                                tech: "Institutional Memory (RAG)",
                                title: "It Never Makes the Same Mistake Twice",
                                desc: "If the bot loses a trade on a specific setup, it remembers it. Next time, it recalls that \"pain\" and avoids the bad trade. It gets smarter every single week."
                            },
                            {
                                tech: "News Attack Logic™",
                                title: "No More News Blowouts",
                                desc: "Stop worrying about NFP or CPI. The system reads the calendar and locks the gates before high-impact news hits, keeping your capital safe from slippage."
                            },
                            {
                                tech: "Dynamic Risk Scaling",
                                title: "Bet Big Only When Sure",
                                desc: "Instead of betting 1% on every single trade, the AI bets small (0.5x) when uncertain and big (2.0x) only on \"Sniper\" setups with high confidence."
                            }
                        ].map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                className="group grid grid-cols-1 md:grid-cols-12 gap-6 p-6 md:p-8 rounded-2xl bg-gray-900/40 border border-gray-800 hover:border-cyan-500/30 transition-all items-center"
                            >
                                {/* Left: The Tech */}
                                <div className="md:col-span-4">
                                    <div className="text-xs font-mono text-cyan-500 mb-2 uppercase tracking-wider">The Technology</div>
                                    <h3 className="text-xl font-bold text-white group-hover:text-cyan-400 transition-colors">{item.tech}</h3>
                                </div>

                                {/* Divider (Arrow on Desktop, Line on Mobile) */}
                                <div className="md:col-span-1 flex justify-center py-2 md:py-0">
                                    <ArrowRight className="text-gray-700 group-hover:text-cyan-500 transition-colors rotate-90 md:rotate-0" />
                                </div>

                                {/* Right: The Benefit */}
                                <div className="md:col-span-7">
                                     <div className="text-xs font-mono text-green-500 mb-2 uppercase tracking-wider">The Benefit</div>
                                    <h4 className="text-lg font-bold text-white mb-2">{item.title}</h4>
                                    <p className="text-gray-400 leading-relaxed text-sm md:text-base">
                                        {item.desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 3.1 VISION SHADOW MODE EXAMPLE */}
            <section className="py-24 bg-black relative border-t border-gray-900">
                 <div className="max-w-5xl mx-auto px-6">
                    <div className="md:p-2 rounded-3xl bg-gradient-to-b from-gray-800 to-black p-[1px]">
                        <div className="bg-gray-950 rounded-[23px] overflow-hidden relative">
                             {/* Header */}
                             <div className="p-8 md:p-12 text-center">
                                  <div className="inline-flex items-center gap-2 px-3 py-1 bg-red-900/30 border border-red-500/30 rounded-full mb-6 text-red-400 text-xs font-mono tracking-widest uppercase">
                                     <AlertTriangle size={12} />
                                     Case Study: AI Intervention
                                 </div>
                                 <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">"The AI Disagrees with the Algo"</h3>
                                 <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
                                     In this example, standard indicators signaled <span className="text-white font-bold">'Range' (Sideways)</span>. However, our <span className="text-purple-400 font-medium">Vision Shadow Mode</span> detected a visual price crash. The AI overruled the math and blocked the trade, saving the user from catching a falling knife.
                                 </p>
                             </div>

                             {/* Image Container */}
                             <div className="relative">
                                 <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-gray-950 to-transparent z-10 w-full"></div>
                                 <img 
                                     src="/vision_example.png" 
                                     alt="Hon AI Vision Shadow Mode Example" 
                                     className="w-full h-auto opacity-90 hover:opacity-100 transition-opacity duration-700"
                                 />
                                 <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-gray-950 to-transparent z-10"></div>
                             </div>
                        </div>
                    </div>
                 </div>
            </section>

            {/* 4. DASHBOARD VISUALIZATION */}
            <section className="py-24 bg-gray-950 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cyan-900/10 via-gray-950 to-gray-950"></div>
                
                <div className="max-w-7xl mx-auto px-6 relative z-10">
                     <div className="mb-12 flex flex-col md:flex-row items-end justify-between gap-6">
                        <div>
                            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">Institutional Visibility</h2>
                             <p className="text-gray-400">Stop guessing. See exactly why the AI makes every decision.</p>
                        </div>
                        <div className="flex items-center gap-4 text-sm font-mono text-cyan-400">
                            <span className="flex items-center gap-2"><span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span> LIVE FEED</span>
                            <span className="opacity-50">|</span>
                            <span>v2.4.0 STABLE</span>
                        </div>
                     </div>
                     
                     <div className="p-1 md:p-4 bg-gray-800/50 rounded-2xl border border-gray-700/50 shadow-2xl backdrop-blur-sm">
                        <DashboardSvg />
                     </div>
                     
                     <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
                        <div className="flex items-start gap-4">
                            <Activity className="text-cyan-500 mt-1" />
                            <div>
                                <h4 className="font-bold text-white">Live Sentiment</h4>
                                <p className="text-sm text-gray-400 mt-1">See exactly why the AI is Bullish or Bearish based on candle array analysis.</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <TrendingUp className="text-green-500 mt-1" />
                            <div>
                                <h4 className="font-bold text-white">News Intelligence</h4>
                                <p className="text-sm text-gray-400 mt-1">Reads deviation between Forecast vs Actual data instantly.</p>
                            </div>
                        </div>
                         <div className="flex items-start gap-4">
                            <Lock className="text-yellow-500 mt-1" />
                            <div>
                                <h4 className="font-bold text-white">Execution Logs</h4>
                                <p className="text-sm text-gray-400 mt-1">Track Entry, Stop Loss, and Take Profit updates in real-time.</p>
                            </div>
                        </div>
                     </div>
                </div>
            </section>

             {/* 4. KEY CAPABILITIES */}
             <section className="py-24 bg-black border-t border-gray-900">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-16 text-center text-white">Defensive & Offensive Capabilities</h2>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {/* FEATURE A */}
                        <div className="group p-6 bg-gray-900 border border-gray-800 hover:border-cyan-500/50 transition-all rounded-xl">
                            <Zap className="text-cyan-500 mb-4 group-hover:scale-110 transition-transform" size={32} />
                            <h3 className="text-xl font-bold text-white mb-2">News Attack Logic™</h3>
                            <p className="text-sm text-gray-400">Most bots turn off during news. We wake up. The AI reads inflation deviations and trades the volatility only after the news.</p>
                        </div>
                        
                        {/* FEATURE B */}
                        <div className="group p-6 bg-gray-900 border border-gray-800 hover:border-purple-500/50 transition-all rounded-xl">
                            <Eye className="text-purple-500 mb-4 group-hover:scale-110 transition-transform" size={32} />
                            <h3 className="text-xl font-bold text-white mb-2">Vision Shadow Mode</h3>
                            <p className="text-sm text-gray-400">We feed raw price geometry to the Strategist. It detects complex structures (Flags, Pennants) that math-algos miss.</p>
                        </div>
                        
                        {/* FEATURE C */}
                        <div className="group p-6 bg-gray-900 border border-gray-800 hover:border-red-500/50 transition-all rounded-xl">
                            <AlertTriangle className="text-red-500 mb-4 group-hover:scale-110 transition-transform" size={32} />
                            <h3 className="text-xl font-bold text-white mb-2">Stop Hunt Protection</h3>
                            <p className="text-sm text-gray-400">If a liquidity grab involves a fake-out, the AI switches to "Reversal Mode", trading with the banks, not against them.</p>
                        </div>
                        
                        {/* FEATURE D */}
                        <div className="group p-6 bg-gray-900 border border-gray-800 hover:border-yellow-500/50 transition-all rounded-xl">
                            <BarChart2 className="text-yellow-500 mb-4 group-hover:scale-110 transition-transform" size={32} />
                            <h3 className="text-xl font-bold text-white mb-2">Dynamic Risk Scaling</h3>
                            <p className="text-sm text-gray-400">1.0x for Standard charts. 2.0x for Sniper setups. We bet small when unsure, and big when we know.</p>
                        </div>
                    </div>
                </div>
            </section>

             {/* FOOTER */}
             <footer className="py-12 bg-gray-950 border-t border-gray-900">
                <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center opacity-50 text-sm">
                    <div className="mb-4 md:mb-0">
                        <span className="font-bold text-white">HON AI SENTINEL</span> {/* A Product of KSQuantitative */}
                    </div>
                    <div className="flex gap-6">
                        <Link to="/contact-us" className="hover:text-white transition">Contact Support</Link>
                    </div>
                </div>
                <div className="max-w-7xl mx-auto px-6 mt-8 text-xs text-gray-700 text-center max-w-4xl leading-relaxed">
                     Disclaimer: Trading foreign exchange and cryptocurrencies carries a high level of risk and may not be suitable for all investors. 
                     The Hon AI Sentinel is a tool for assisted decision-making, not a guarantee of profit. Past performance of AI models is not indicative of future results.
                </div>
             </footer>
        </div>
    );
};

export default HonAiSentinel;
